import React from "react";
import Banner from "./Banner";
import { useEffect, useState } from "react";
const TermsAndServices = () => {
  const [htmlContent, setHtmlContent] = useState("");
    
      useEffect(() => {
        fetch("/PolicyPage/termandcondition.txt")
          .then((response) => response.text())
          .then((data) => setHtmlContent(data))
          .catch((error) => console.error("Error loading HTML file:", error));
      }, []);
  return (
    // <div className="w-full min-h-screen py-6 md:py-10 px-3 md:px-6 lg:px-8">
    //   <div
    //     className="max-w-7xl space-y-5 mx-auto w-full"
    //   >
    //     <h1 className="font-semibold text-center text-[#0F172A] text-3xl md:text-4xl lg:text-5xl">Terms and Conditions</h1>
    //     <p className="text-[#1F2937] text-base md:text-lg">Welcome to NextEra Research!</p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       These terms and conditions outline the rules and regulations for the
    //       use of {`NextEra Research's`} Website, located at {" "}
    //       <a
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         href="https://nexteraresearch.in/"
    //         className="text-blue-600 underline"
    //       >
    //         https://nexteraresearch.in/
    //       </a>
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       By accessing this website we assume you accept these terms and
    //       conditions. Do not continue to use NextEra Research if you do not
    //       agree to take all of the terms and conditions stated on this page.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       The following terminology applies to these Terms and Conditions,
    //       Privacy Statement and Disclaimer Notice and all Agreements: {`"Client"`}, {`"You"`} and {`"Your"`} refers to you, the person log
    //       on this website and compliant to the Research Analyst{`'s`} terms and
    //       conditions. {`"The Research Analyst"`}, {`"Ourselves"`}, {`"We"`}, {`"Our"`} and {`"Us"`} refers to our Research Analyst. {`"Party"`}, {`"Parties"`}, or {`"Us"`} refers to both the Client and ourselves. All terms refer to
    //       the offer, acceptance and consideration of payment necessary to
    //       undertake the process of our assistance to the Client in the most
    //       appropriate manner for the express purpose of meeting the Client{`'s`} needs in respect of provision of the Research Analyst{`'s`} stated services, in
    //       accordance with and subject to, prevailing law of in. Any use of the
    //       above terminology or other words in the singular, plural,
    //       capitalization and/or he/she or they, are taken as interchangeable and
    //       therefore as referring to same.
    //     </p>

    //     <h3 className="text-[#0F172A] text-xl md:text-2xl font-semibold">Cookies</h3>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       We employ the use of cookies. By accessing NextEra Research, you
    //       agreed to use cookies in agreement with the {`NextEra Research's`} Privacy Policy.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       Most interactive websites use cookies to let us retrieve the {`user's`} details for each visit. Cookies are used by our website to
    //       enable the functionality of certain areas to make it easier for people
    //       visiting our website. Some of our affiliate/advertising partners may
    //       also use cookies.
    //     </p>

    //     <h3 className="text-[#0F172A] text-xl md:text-2xl font-semibold">License</h3>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       Unless otherwise stated, NextEra Research and/or its licensors own
    //       the intellectual property rights for all material on RUPESH RAJ PROPRIETOR OF NEXTERA RESEARCH
    //       Mart. All intellectual property rights are reserved. You may access
    //       this from NextEra Research for your own personal use subjected to
    //       restrictions set in these terms and conditions.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">You must not:</p>
    //     <ul className="list-disc text-[#1F2937] text-base md:text-lg pl-5">
    //       <li>Republish material from NextEra Research</li>
    //       <li>Sell, rent or sub-license material from NextEra Research</li>
    //       <li>Reproduce, duplicate or copy material from NextEra Research</li>
    //       <li>Redistribute content from NextEra Research</li>
    //     </ul>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       Parts of this website offer an opportunity for users to post and
    //       exchange opinions and information in certain areas of the website.
    //       NextEra Research does not filter, edit, publish or review Comments
    //       prior to their presence on the website. Comments do not reflect the
    //       views and opinions of NextEra Research, its agents and/or
    //       affiliates. Comments reflect the views and opinions of the person who
    //       post their views and opinions. To the extent permitted by applicable
    //       laws, RUPESH RAJ PROPRIETOR OF NEXTERA RESEARCH shall not be liable for the Comments or for any
    //       liability, damages or expenses caused and/or suffered as a result of
    //       any use of and/or posting of and/or appearance of the Comments on this
    //       website.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       NextEra Research reserves the right to monitor all Comments and to
    //       remove any Comments which can be considered inappropriate, offensive
    //       or causes breach of these Terms and Conditions.
    //     </p>

    //     <p className="text-[#1F2937] text-base md:text-lg">You warrant and represent that:</p>

    //     <ul className="list-disc text-[#1F2937] text-base md:text-lg pl-5">
    //       <li>
    //         You are entitled to post the Comments on our website and have all
    //         necessary licenses and consents to do so;
    //       </li>
    //       <li>
    //         The Comments do not invade any intellectual property right,
    //         including without limitation copyright, patent or trademark of any
    //         third party;
    //       </li>
    //       <li>
    //         The Comments do not contain any defamatory, libelous, offensive,
    //         indecent or otherwise unlawful material which is an invasion of
    //         privacy
    //       </li>
    //       <li>
    //         The Comments will not be used to solicit or promote business or
    //         custom or present commercial activities or unlawful activity.
    //       </li>
    //     </ul>

    //     <p className="text-[#1F2937] text-base md:text-lg">
    //       You hereby grant NextEra Research a non-exclusive license to use,
    //       reproduce, edit and authorize others to use, reproduce and edit any of
    //       your Comments in any and all forms, formats or media.
    //     </p>
    //   </div>
    //   <Banner />
    // </div>
    <div className="py-12" dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default TermsAndServices;